import React, { Component, useState } from "react";
import {useNavigate } from "react-router-dom";
import Logo from "../../images/logo.png";
import UserProfile from "../../images/user.png";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import swal from "sweetalert";

import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css


import { useTranslation } from "react-i18next";

function Header(props) {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [langActive, setLangActive] = useState(localStorage.getItem("selectLang"));
  const UserFName = localStorage.getItem("fname")
  const UserLName = localStorage.getItem("lname")
  const UserUimage = localStorage.getItem("nameImage")

  const changeLanguage = (event, param) => {
    console.log(event);
    console.log(param);
    setLangActive(param);
    localStorage.setItem("selectLang", param);

    const languageValue = param //event.target.value
    i18n.changeLanguage(languageValue);
  }

  const logout =() => {

    confirmAlert({
      title: "Confirm to log out",
        message: "Are you sure want to log out?",
        buttons:[
          {
            label: "Yes",
            onClick: () => {
              localStorage.removeItem("token")
              localStorage.removeItem("userData")
              localStorage.removeItem("fname")
              localStorage.removeItem("lname")
              localStorage.removeItem("nameImage")
              localStorage.removeItem("otpCounter")
              localStorage.removeItem("USERLOGIN")
              swal({
                title: "Log Out",
                text: "You have successfully logged out!",
                icon: "success",
                button: "OK",
              });
              navigate("/");
            } 
          },
          {
            label: "No",
            onClick: () => {},
          }
        ]

    })
    }
  return (
    <>
      <div className="header">
            <Navbar bg="white" expand="lg">
                <Container>
                <Navbar.Brand href="/features"><img src={Logo} alt="Way Almanac Engine​" /></Navbar.Brand>
                {/* <Navbar.Toggle aria-controls="basic-navbar-nav" /> */}
                {/* <Navbar.Collapse id="basic-navbar-nav"> */}
                    {/* <Nav className="ms-auto"> */}
                    
                    <div className="d-flex">
                    <div className="btn-box">
                    <button type="button" onClick={event => changeLanguage(event, 'en')}  className={(langActive == 'en') ? 'btn eng-btn active' : 'btn eng-btn'}>English</button>
                    <button type="button" onClick={event => changeLanguage(event, 'zh')} className={(langActive != 'en') ? 'btn chi-btn active' : 'btn chi-btn'}>华语</button>
                    </div>

                    <div className="header-dropdown">
                      <p>{UserFName} <br/> {UserLName}</p>
                      <p className="user-image">{UserUimage}</p>
                      <NavDropdown  id="basic-nav-dropdown">
                          <NavDropdown.Item href="/change-password">Change Password</NavDropdown.Item>
                          <NavDropdown.Divider />
                          <NavDropdown.Item onClick={logout}>Logout</NavDropdown.Item>                         
                      </NavDropdown>
                    </div>
                    </div>
                    {/* </Nav> */}
                {/* </Navbar.Collapse> */}
                </Container>
            </Navbar>
      </div>
    </>
  );
}

export default Header;
